import Act from "../actions";

import { safeArray } from "../../common/utils";
import { LOG_CLASSIFICATION, ERROR_CODE } from "../../config/CONSTANTS";

const initState = {
  error: [
    // {
    //   key: Date.now(),
    //   code: ERROR_CODE.systemCrashError,
    //   userName: "gary wu",
    //   message: "something went wrong",
    //   info: null,
    //   operation: "",
    //   classification: LOG_CLASSIFICATION.error,
    //   time: Date.now(), // 發生錯誤的時間
    // },
  ],
};

const errorReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.ERROR_SET_ERROR:
      return {
        ...state,
        error: [...state.error, ...safeArray(action.payload)],
      };
    case Act.ERROR_CLEAR_ERROR:
      return {
        ...state,
        error: state.error.filter((err) => err.key !== action.payload.key),
      };
    case Act.ERROR_CLEAR_ALL_ERROR:
      return {
        ...state,
        error: [],
      };
    default:
      return state;
  }
};

export default errorReducer;
